import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = auth
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
  try {
    const { data } = await api.get("/auth/me");
    setUser(data);
  } catch {
    setUser(false);
  } finally {
    setLoading(false);
  }
}, []);

useEffect(() => {
  refresh();
}, [refresh]);

  const login = async (email, password) => {
  try {
    const { data } = await api.post("/auth/login", { email, password });

    if (data.access_token) {
      localStorage.setItem("access_token", data.access_token);
    }

    setUser(data);
    return { ok: true };
  } catch (e) {
    return { ok: false, error: formatApiError(e) };
  }
};
  
  const completeApprovedLogin = useCallback((data) => {
    if (data?.access_token) localStorage.setItem("access_token", data.access_token);
    setUser(data);
  }, []);

  const logout = async () => {
  try {
    await api.post("/auth/logout");
  } catch (_e) {
    /* ignore */
  }

  localStorage.removeItem("access_token");
  setUser(false);
};

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, completeApprovedLogin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
